import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { select } from 'satcheljs/lib/legacy';
import { getUserConfiguration } from 'owa-session-store';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isReadingPaneOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var readingPanePositionSelected = getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact);
    var actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
    var showReadingPaneOnFirstLoadSelected = getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad);
    return (readingPanePositionSelected !== userOptions.GlobalReadingPanePositionReact ||
        actionAfterMoveKey !== userOptions.NextSelection ||
        showReadingPaneOnFirstLoadSelected !== userOptions.ShowReadingPaneOnFirstLoad);
});
//# sourceMappingURL=isReadingPaneOptionDirty.js.map